export const STUDENT = 'Studente / Student';
export const TEACHER = 'Docente / Teacher';
export const FUNCTIONARY = 'Funzionario';
export const PROFESSIONIST = 'Professionista';
